import { routePaths } from '@/shared/config/routePaths';
import { Applications } from '@filament/react/icons/applications';
import { Home } from '@filament/react/icons/home';
import { Money } from '@filament/react/icons/money';

type IconType = typeof Home;

export type MenuLeaf = {
    id: string;
    name: string;
    icon?: IconType;
    href: string;
};

export type MenuSection = {
    id: string;
    name: string;
    children: MenuLeaf[];
};

export type MenuItem = MenuLeaf | MenuSection;

export const isSection = (item: MenuItem): item is MenuSection => 'children' in item;

export const menuItems: MenuItem[] = [
    {
        id: 'home',
        name: 'Home',
        icon: Home,
        href: routePaths.home,
    },
    {
        id: 'poc',
        name: 'drools-editor',
        icon: Money,
        href: routePaths.droolsEditor,
    },
    {
        id: 'administration',
        name: 'Administration',
        children: [
            {
                id: 'administration-organizations',
                name: 'Organizations',
                icon: Applications,
                href: routePaths.administration.organizations.full,
            },
            {
                id: 'administration-entitlements-manager',
                name: 'Entitlements Manager',
                icon: Money,
                href: routePaths.administration.entitlementsManager.full,
            },
        ],
    },
    {
        id: 'organizations',
        name: 'Organizations',
        children: [
            {
                id: 'organization-details',
                name: 'Organization Details',
                icon: Applications,
                href: routePaths.organizations.details.full,
            },
            {
                id: 'entitlements',
                name: 'Entitlements',
                icon: Money,
                href: routePaths.organizations.entitlements.full,
            },
        ],
    },
    {
        id: 'virtual-devices-section',
        name: 'Virtual Medical Devices',
        children: [
            {
                id: 'device-models',
                name: 'Device Models',
                icon: Applications,
                href: routePaths.virtualDevices.deviceModels.full,
            },

             {
                id: 'association-policies',
                name: 'Association Policies',
                icon: Applications,
                href: routePaths.virtualDevices.associationPolicies.full,
            },
        ],
    },
];








